import React, { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import useNavigateTo from 'hooks/useNavigateTo'
import TextLink from 'LuxKit/TextLink'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import Caption from 'LuxKit/Typography/Caption'

const NavigationBox = styled.div`
  background: transparent;
  border-radius: ${rem(8)};
  padding: ${rem(8)} ${rem(12)};
  min-width: ${rem(180)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem(4)};
  
  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`

interface Props {
  linkTourDetails: {
    tourId: string
    assignYear: number
    title: string
  }
}

function TourV2YearNavigationBoxes(props: Props) {
  const { linkTourDetails } = props
  const navigateTo = useNavigateTo()

  const handleLinkTourClick = useCallback(() => {
    navigateTo(`/tour/tour-${linkTourDetails.tourId}`)
  }, [navigateTo, linkTourDetails])

  return (
    <NavigationBox>
      <Caption variant="large" weight="bold">
        {linkTourDetails.title}
      </Caption>
      <TextLink
        size="caption"
        startIcon={<LineCalendarIcon />}
        weight="regular"
        onClick={handleLinkTourClick}
      >
        Explore {linkTourDetails.assignYear} tour
      </TextLink>
    </NavigationBox>
  )
}

export default React.memo(TourV2YearNavigationBoxes)
